
<ng-container *ngIf="expiredSessionModal">
  <ng-container *ngIf="isMobile else web">
    <app-mobile-kamona-message-widget
      [title]="modalInfo.title"
      [iconType]="modalInfo.iconType"
      [btnText]="modalInfo.btnText"
      [btnType]="modalInfo.btnType"
      [modalType]="modalInfo?.modalType"
      (emitCancel)="handleCloseModal()"
      [description]="modalInfo.description">
    </app-mobile-kamona-message-widget>
  </ng-container>
</ng-container>

<ng-template #web>
  <app-web-kamona-message-widget
    [title]="modalInfo.title"
    [iconType]="modalInfo.iconType"
    [btnText]="modalInfo.btnText"
    [btnType]="modalInfo.btnType"
    [modalType]="modalInfo?.modalType"
    (emitCancel)="handleCloseModal()"
    [description]="modalInfo.description">
  </app-web-kamona-message-widget>
</ng-template>
